<template>
	<div class="page_content module_course" aria-label="Assessment learn Page Content" :class="addPrintClass()">

		<course-header :course-id="course.uuid" :entityUuid="entityUuid" class="header_assessment_learn"></course-header>

		<div class="row page-content" :class="isTocOpen ? 'toc_activated' : ''">
			<div class="col-12 assessment-learn can_full_screen ace_sec">

				<div class="header">
					<span v-if="entity.fileType === 'assessment'" class="icon icon-assessment"></span>
					<span class="heading ace_sec_hd">
            <!--<b-link :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: 'LearningTopic', entityUuid: ancestorUuid } }">{{ancestor}}</b-link>
           >
           <b-link :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: 'LearningTopic', entityUuid: parentUuid } }">{{parent}} </b-link>
           > --> {{entity.title}}</span>
					<div class="btn_container">
                        <template v-if="islocalPracticeReviewLoaded">
                            <b-button @click="done(course.uuid, entity.objectType, entity.uuid)" class="btn button-primary next"> Done </b-button>
                        </template>
            			<full-screen-method></full-screen-method>
          			</div>
				</div>

				<div v-if="loadLaunchAssessmentWidget" class="assessment-container">
					<template v-if="((course.courseType === 'SELECTIVE_RELEASE') || (course.courseType === 'CONVERSATION_QUEST'))">
					   <quest-launch-assessment :uuid="entityUuid" :course-id="uuid" :session-id="sessionId" @localPracticeReviewLoaded="showDoneButton"></quest-launch-assessment>
					</template>
					<template v-else>
					   <launch-assessment :uuid="entityUuid" :course-id="uuid" :session-id="sessionId" @localPracticeReviewLoaded="showDoneButton"></launch-assessment>
					</template>
            	</div>

			</div>
		</div>

		<div class="print_msg">
			Print is not available
		</div>

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CourseHeader from './CourseHeader'
import CourseNav from './CourseNav'
import TOC from './TOC'
import LaunchAssessment from '../../assessment/components/LaunchAssessment'
import QuestLaunchAssessment from '../../assessment/components/QuestLaunchAssessment'
import fullScreenMethod from '../../common/components/fullScreenMethod'

export default {
  name: 'course-learn',
  props: ['uuid', 'entityType', 'entityUuid', 'sessionId', 'action'],
  components: {
    CourseHeader,
    CourseNav,
    TOC,
    LaunchAssessment,
    QuestLaunchAssessment,
    fullScreenMethod
  },
  data: () => {
    return {
      page: 1,
      parent: null,
      parentUuid: null,
      ancestor: null,
      ancestorUuid: null,
      loadLaunchAssessmentWidget: false,
      islocalPracticeReviewLoaded: false
    }
  },

  mounted () {
    this.loadCourse()
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadEntityDetail',
      'startActivity',
      'loadLogDashboardActivity'
    ]),

    loadCourse () {
      if (this.action) {
        let entityUuid = this.uuid + '&resourceUuid=' + this.entityUuid
        this.loadLogDashboardActivity({action: this.action, page: 'courseLearn', link: '', entityUuid: entityUuid})
      }
      this.loadCourseDetail(this.uuid)
      const entityDetailInfo = {
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }
      this.loadEntityDetail(entityDetailInfo).then((res) => {
        if (res && res.type === 'ASSESSMENT') {
          this.loadLaunchAssessmentWidget = true
        }
        var i = 0
        var j = 0
        var parentAncestorId = null
        for (i = 0; i < this.linearTopics.length; i++) {
          if (this.linearTopics[i].uuid === this.entity.ancestor) {
            if (this.linearTopics[j].title.indexOf(':') > -1) {
              this.parent = this.linearTopics[i].title.split(':')[0]
            } else {
              this.parent = this.linearTopics[i].title
            }
            this.parentUuid = this.linearTopics[i].uuid
            parentAncestorId = this.linearTopics[i].ancestor
            break
          }
        }

        if (parentAncestorId != null) {
          for (j = 0; j < this.linearTopics.length; j++) {
            if (this.linearTopics[j].uuid === parentAncestorId) {
              if (this.linearTopics[j].title.indexOf(':') > -1) {
                this.ancestor = this.linearTopics[j].title.split(':')[0]
              } else {
                this.ancestor = this.linearTopics[j].title
              }
              this.ancestorUuid = this.linearTopics[j].uuid
              break
            }
          }
        }
      })
      var startActivity = {
        'userId': localStorage.getItem('userid'),
        'entityUuid': this.entityUuid
      }
      this.startActivity(startActivity)
    },

    showDoneButton (value) {
      this.islocalPracticeReviewLoaded = value
    },

    done (uuid, entityType, entityUuid) {
      this.$router.push({ name: 'entityDetail', params: { uuid: uuid, entityType: entityType, entityUuid: entityUuid } })
    },
		isPrintDisable () {
      if (this.enabledFeatures && this.enabledFeatures['disablePrint']) {
        return this.enabledFeatures['disablePrint'].enabled
      }
      return false
    },
    addPrintClass () {
      if (this.isPrintDisable()) {
        return 'no_print_win'
      } else {
        return ''
      }
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'entity': state => state.course.entity,
			'isTocOpen': state => state.course.isTocOpen,
			'enabledFeatures': state => state.institution.enabledFeatures,
      'linearTopics': state => state.course.linearTopics
    })
  },

  watch: {
    entityUuid (newId) {
      if (newId) {
        this.loadCourse()
      }
    }
  }
}
</script>

<style scoped>

.header {
	background: #f7e5a8;
	margin-bottom: 30px;
	float: left;
    width: 100%;
	padding-left: 20px;
	height:62px;
}
.heading {
	float: left;
	font-size: 20px;
	margin-top: 17px;
	color: rgb(79, 79, 79);
	font-family: robotoSlab_Light;
	max-width: calc(100% - 195px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.btn_container {
	float: right;
    margin: 17px 18px 0 18px;
}
.container {
	width: 90%;
	max-width: 90%;
	margin-left: 5%;
	height: 98%;
}
.container iframe {
	width: 90% !important;
	margin-left: 5%;
	height: 95%;
}

.content{
  padding-top: 40px;
  margin-right: 30px;
  margin-left: 30px;
}

.course-nav{
  background:#e1e1e1;
  min-height: 500px;
}
.coure-nav-list-item{
  background:#e1e1e1;
  border: none;
}

.course-thumbnail{
  background:#f8f9fa;
  min-height: 500px;
}

.course-information{
  margin-top:20px;
}

.course-description{
  padding-top:20px;
  padding-left:20px;
  padding-right:20px;
}

.course-description-card{
  background:#f8f9fa;
  border-color: #f8f9fa;
}

.topic-list-item{
}

.entity-nav{
  background: #f8f9fa;
}
.pull-left{
  float:left;
}

.learning{
  margin-top: 30px;
}

.course-description {
	padding: 0px;
}
.assessment-container {
	padding-left: 5%;
	width: 95%;
}
</style>



// WEBPACK FOOTER //
// src/app/course/components/AssessmentLearn.vue